import { fetchApi } from "../utils/fetchApi";
import { postApi } from "../utils/postApi";

// Bulk Aggregation
// export const fetchAnalyticsAggregation = ({ refresh, filters, options }) =>
//   fetchApi({url: 'analytics/aggregation', method: 'POST', data: { refresh, filters, options }});

export const fetchAnalyticsAggregation = async ({ refresh, filters, options }) => {
  try {
    const param = { refresh, filters, options }
    console.log("param", param)
    const response = await postApi({url: 'analytics/aggregation', method: 'POST', data: { refresh, filters, options } });
    return response?.data ?? response;
  } catch (error) {
    console.error('Analytics Aggregation Error:', {message: error.message, status: error.response?.status, data: error.response?.data,});
    throw error;
  }
};